var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnalytics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.1667V3.33955C10 3.10017 10.1023 2.87219 10.2811 2.71302C10.4599 2.55385 10.6982 2.47866 10.936 2.50638C14.3642 2.93556 17.0645 5.63579 17.4936 9.06404C17.5214 9.30182 17.4462 9.54011 17.287 9.71891C17.1278 9.89772 16.8998 10 16.6605 10H10.8333C10.3731 10 10 9.62692 10 9.1667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66678 3.9668C3.79627 5.26285 2.12698 8.29923 2.57075 11.4173C3.01451 14.5355 5.46463 16.9856 8.58274 17.4293C11.7009 17.8731 14.7372 16.2038 16.0333 13.3333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnalytics);
export default ForwardRef;